import PropTypes from 'prop-types'
import React from 'react'
import AnimateHeight from 'react-animate-height'
import ZoneResidentsList from './ZoneResidentsList'
import ZonesTitleBar from './ZonesTitleBar'

export default class NoZone extends React.Component {
  state = {
    isShowingContent: true
  }

  toggleOpen = () => {
    this.setState((prevState) => ({
      isShowingContent: !prevState.isShowingContent
    }))
  }

  render() {
    const { onEditResident, residents } = this.props
    const { isShowingContent } = this.state
    if (!residents || !residents.length) return null
    return (
      <div style={{ paddingTop: 20, paddingBottom: 20 }}>
        <ZonesTitleBar
          isOpen={isShowingContent}
          isNoZone
          title="Unassigned"
          toggleOpen={this.toggleOpen}
        />
        <AnimateHeight
          animateOpacity
          duration={500}
          height={isShowingContent ? 'auto' : 0}
        >
          <ZoneResidentsList
            onEditResident={onEditResident}
            residents={residents}
          />
        </AnimateHeight>
      </div>
    )
  }
}

NoZone.propTypes = {
  onEditResident: PropTypes.func.isRequired,
  residents: PropTypes.array.isRequired
}
